<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="$apollo.loading">
      <div :class="{'activeLoading':activeLoading}" id="loading-default"
           class="vs-con-loading__container loading-example"></div>
    </div>
    <vs-table
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      v-model="selected"
      :total="totalItems"
      pagination
      max-items="10"
      :data="applicationList">
      <template slot="header">
        <h3>
          Accepted Application List
        </h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="email">
          ID
        </vs-th>
        <vs-th sort-key="email">
          Product Name
        </vs-th>
        <vs-th sort-key="username">
          Mobile No.
        </vs-th>
        <vs-th sort-key="website">
          Application Date
        </vs-th>
        <vs-th sort-key="id">
          Application Status
        </vs-th>
        <vs-th sort-key="id">
          Action
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{paddingId(data[indextr].id)}}
          </vs-td>
          <vs-td :data="data[indextr].product">
            {{data[indextr].product.product}}
          </vs-td>

          <vs-td :data="data[indextr].user.phone">
            {{data[indextr].user.phone}}
          </vs-td>

          <vs-td :data="data[indextr].accepting_date">
            {{data[indextr].accepting_date}}
          </vs-td>

          <vs-td :data="data[indextr].status">
            <vs-chip color="success" class="product-order-status">{{data[indextr].status =='5'?
              'Accepted':'Accepted'}}
            </vs-chip>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <div class="demo-alignment">
            <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          class="clickable"/>
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2 clickable"/>-->
              <vs-button color="success" class="mr-3 mt-0" @click="applicationDetal(data[indextr].id)">Reprocess</vs-button>
              <vs-button color="success" class="mr-3 mt-0" @click="popupActive2=true, updateId=data[indextr].id, invoiceNumber = data[indextr].invoice_number">Update Sales Doc No</vs-button>

              <!--<vx-tooltip text="View and Re-process">
            <feather-icon icon="EyeIcon" @click="applicationDetal(data[indextr].id)"
                          svgClasses="w-5 h-5 hover:text-success stroke-current"
                          class="ml-2 clickable"/> Reprocess
              </vx-tooltip>
              <vx-tooltip text="Download Contract">-->
            <feather-icon icon="ArrowDownIcon" @click="downloadAgreement(data[indextr].id)"
                          svgClasses="w-5 h-5 hover:text-success stroke-current"
                          class="ml-2 clickable mt-0"/>
<!--              </vx-tooltip>-->
            </div>
          </vs-td>
        </vs-tr>
        <template>
          <div class="demo-alignment">
            <vs-popup classContent="popup-example" title="Update Sales Doc No" :active.sync="popupActive2">
              <vx-card title="Sales Doc No">
                <vs-input class="inputx" placeholder="New Sales Doc No" v-model="invoiceNumber"/>
                <div class="w-full text-right">
                  <vs-button :disabled="invoiceNumber===''" @click="updateInvoice(updateId, invoiceNumber)" color="success" type="filled">Update Sales Doc No</vs-button>
                </div>
              </vx-card>

            </vs-popup>
          </div>
        </template>
      </template>
    </vs-table>

    <pre ref="pre"></pre>
  </div>
</template>
<script>
  import addInvoice from '../../graphql/InvoiceAdd.gql'
  import moduleDataList from '@/store/data-list/moduleDataList.js'
  import {ME} from '../../graphql/userinfo'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        totalItems: 0,
        selected: [],
        selectedPgae: 1,
        itemsPerPage: 7,
        isMounted: false,
        pagination: '',
        userInfo: '',
        applicationList: [],
        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData: {},
        activeLoading: false,
        pdfFile:'',
        popupActive2: false,
        updateId:'',
        invoiceNumber:''
      }
    },
    apollo: {
      me: {
        query: gql`
        query me($status: Int!, $orderBy: [OrderByClause!], $first: Int!, $page: Int){
            me{
            id
            manager_name
            phone
            email
            address
            api_token
            division{
              id
              division
            }
            district{
              id
              district
            },
            purchases(status : $status, orderBy: $orderBy, first: $first, page: $page){
              paginatorInfo{
                count
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                perPage
                total
              }
              data{
                id
                used_location
                location
                brand
                invoice_number
                price_range
                status
                accepting_date
                guarantors{
                  id
                  name
                  phone
                  email
                  relationship
                  status
                  ekyc{
                    id
                    phone
                    nid
                    email
                    status
                  }

                }
                product{
                  id
                  product
                },
                user{
                  id
                  name
                  phone
                  email
                  ekyc{
                    id
                    phone
                    email
                  }
                }
              }
            }
           }
         }
        `,
        variables () {
          // Use vue reactive properties here
          return {
            status: 5,
            first: 10,
            page: this.selectedPgae,
            orderBy: [{
              column: 'id',
              order: 'DESC'
            }]
          }
        },
        update: (data) => data.me
      }
    },
    watch: {
      me (value) {
        this.applicationList = value.purchases.data
        console.log("List",this.applicationList);
        this.pagination = value.purchases.paginatorInfo
        this.totalItems = this.pagination.total
        this.$apollo.queries.me.refetch();
      },
      '$apollo.loading': function (loading) {
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      }
    },
    computed: {
      currentPage () {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      products () {
        //return this.$store.state.dataList.products
      },
      queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }
    },
    methods: {
      addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData (id) {
        this.$store.dispatch('dataList/removeItem', id).catch(err => {
          console.error(err)
        })
      },
      editData (data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = data
        this.toggleDataSidebar(true)
      },


      toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
      },
      applicationDetal (applicationId) {
        this.$router.push('/applicationDetails/' + applicationId).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      async updateInvoice (id, invoice) {
        console.log(id, invoice);
        await this.$apollo.mutate({
          mutation: addInvoice,
          variables: {
            id: id,
            invoice_number: invoice
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$vs.notify({
            title: 'Save',
            text: 'Invoice Successfully Added.',
            color: "success",
            position: 'top-right'
          })
          this.popupActive2= false
        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
          this.popupActive2= false
        })
      },
      paddingId(id){
        console.log(id.length);
        if(id.length === 1){return 100000000+id;}
        else if(id.length === 2){return 10000000+id;}
        else if(id.length === 3){return 1000000+id;}
        else if(id.length === 4){return 100000+id;}
        else if(id.length === 5){return 10000+id;}
        else if(id.length === 6){return 1000+id;}
        else if(id.length === 7){return 100+id;}
        else if(id.length === 8){return 10+id;}
        else if(id.length === 9){return 1+id;}
        else if(id.length === 10){return id;}
      },
      downloadAgreement(id){
        this.pdfFile =  "https://showroom.butterflygroupbd.com/showroom-backend/storage/agreement_"+id+".pdf";
        return window.open(this.pdfFile);
      },
    },
    created () {
      if (!moduleDataList.isRegistered) {
        this.$store.registerModule('dataList', moduleDataList)
        moduleDataList.isRegistered = true
      }
      this.$store.dispatch('dataList/fetchDataListItems')
    },
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  .clickable {
    cursor: pointer;
  }

  img.product-img.butterfly-product {
    height: 40px;
    width: auto;
  }

  .vs-table--not-data {
    display: none;
  }

  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
